// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"136":"24375e55","161":"ac1c713a","349":"0c375e6c","385":"2b0ced66","395":"3b1b5402","424":"3ff0b9e4","588":"b61ff741","635":"9ea3a932","654":"2de35b50","658":"0810a119","835":"326246fa","847":"488f6604","897":"1a6dc4fe"}[chunkId] + ".chunk.js";
};